import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { PortfolioService } from "src/app/api/portfolio.service";
import { ProfileService } from "src/app/api/profile.service";
import { WebSocketService } from "src/app/api/web-socket.service";
import { MobileWebViewService } from "src/app/services/mobile-web-view.service";
import { ThemeService } from "src/app/services/theme.service";

// TODO: Remove the this.themeService.init() from this component and move it to app.component.ts
// when you have the right design for all pages

@Component({
    selector: "general-layout",
    templateUrl: "./general-layout.component.html",
    styleUrls: ["./general-layout.component.scss"],
    standalone: false
})
export class GeneralLayoutComponent implements OnInit, OnDestroy {
  minifySidebar = false;
  oldLayout = false;
  hideThemeButton = false;

  routerEventsSubscription: Subscription;
  routeSubscription: Subscription;
  isMobileWebView$ = this.mobileWebViewService.isMobileWebView$;
  instantBuyEnabled: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private themeService: ThemeService,
    public mobileWebViewService: MobileWebViewService,
    private profileService: ProfileService,
    private wss: WebSocketService,
    private portfolioService: PortfolioService
  ) {}

  ngOnInit() {
    // Web socket
    this.wss.connect(true);

    this.portfolioService.init();

    // Theme
    this.themeService.init();

    this.routeSubscription = this.route.url.subscribe(() => {
      // initial loading
      this.updateLayoutState();
    });

    this.routerEventsSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // on navigation
        this.updateLayoutState();

        // Theme
        this.themeService.init();
      }
    });

    this.profileService.isInstantBuyEnabled().subscribe(isEnabled => this.instantBuyEnabled = isEnabled);

  }

  ngOnDestroy() {
    this.wss.disconnect();
    this.routeSubscription?.unsubscribe();
    this.routerEventsSubscription?.unsubscribe();
  }

  updateLayoutState() {
    const { data } = this.route.snapshot.firstChild;
    this.minifySidebar = data.minifySidebar || false;
    this.oldLayout = data.oldLayout || false;
    this.hideThemeButton = data.hideThemeButton || false;
  }
}
